<script>
export default {
  props: {
    selectedOrganization: {
      type: Object,
      required: true
    },
    updateOrganization: {
      type: Boolean,
      required: true
    }
  }
}
</script>
<template>
  <v-card v-if="!updateOrganization && selectedOrganization.billingAddress" class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-icon left>mdi-home</v-icon>
        {{ selectedOrganization.billingAddress.billingCompanyName }}
      </v-col>
      <v-col
        v-if="selectedOrganization.billingAddress.billingReceiver"
        cols="12">
        <v-icon left>mdi-account</v-icon>
        {{ selectedOrganization.billingAddress.billingReceiver }}
      </v-col>
      <v-col cols="12">
        <v-icon left>mdi-map-marker</v-icon>
        {{ selectedOrganization.billingAddress.billingStreetAndNumber }},
        {{ selectedOrganization.billingAddress.billingAddressAddition }}
        {{ selectedOrganization.billingAddress.billingZipCode }}
        {{ selectedOrganization.billingAddress.billingCity }}
      </v-col>
      <v-col
        v-if="selectedOrganization.billingAddress.billingCountry"
        cols="12">
        <v-icon left>mdi-earth</v-icon>
        {{ selectedOrganization.billingAddress.billingCountry }}
      </v-col>
      <v-col
        v-if="selectedOrganization.billingAddress.billingTaxId"
        cols="12">
        <v-icon left>mdi-file-document</v-icon>
        <strong>Steuer-ID:</strong> {{ selectedOrganization.billingAddress.billingTaxId }}
      </v-col>
      <v-col
        v-if="selectedOrganization.billingAddress.billingPhoneNumber"
        cols="12">
        <v-icon left>mdi-phone</v-icon>
        {{ selectedOrganization.billingAddress.billingPhoneNumber }}
      </v-col>
    </v-row>
  </v-card>
</template>
